import { useSyncExternalStore } from 'react';

type Listener = () => void;

const progressByTempId = new Map<string, number>();
const listeners = new Set<Listener>();

function emit() {
  listeners.forEach((listener) => listener());
}

export function setUploadProgress(tempId: string, percent: number) {
  progressByTempId.set(tempId, Math.max(0, Math.min(100, percent)));
  emit();
}

export function clearUploadProgress(tempId: string) {
  if (progressByTempId.delete(tempId)) {
    emit();
  }
}

export function clearUploadProgressMany(tempIds: string[]) {
  let changed = false;
  for (const id of tempIds) {
    if (progressByTempId.delete(id)) changed = true;
  }
  if (changed) emit();
}

export function getUploadProgress(tempId: string): number | undefined {
  return progressByTempId.get(tempId);
}

function subscribe(listener: Listener) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function getSnapshot() {
  return progressByTempId;
}

/** React hook: upload percent (0–100) for an optimistic temp-* file id. */
export function useUploadProgress(tempId: string): number | null {
  const map = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  return map.has(tempId) ? (map.get(tempId) as number) : null;
}

/**
 * Temp ids for the in-flight upload batch (set in onMutate, read in
 * mutationFn).
 */
let pendingUploadTempIds: string[] = [];

export function setPendingUploadTempIds(ids: string[]) {
  pendingUploadTempIds = ids;
}

export function getPendingUploadTempIds(): string[] {
  return pendingUploadTempIds;
}
